import { render, staticRenderFns } from "./UserRegistration.vue?vue&type=template&id=4cda9666&"
import script from "./UserRegistration.vue?vue&type=script&lang=js&"
export * from "./UserRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cda9666')) {
      api.createRecord('4cda9666', component.options)
    } else {
      api.reload('4cda9666', component.options)
    }
    module.hot.accept("./UserRegistration.vue?vue&type=template&id=4cda9666&", function () {
      api.rerender('4cda9666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/user/UserRegistration.vue"
export default component.exports